export const CARMEN: string = "Carmen";
const PREFIX: string = CARMEN + ".";

export const LOAD_MANUAL_PROGRESS: string = PREFIX + "LoadManualProgress";
export const FORCE_ONBOARDING_HINT: string = PREFIX + "ForceOnboardingHint";
export const FORCE_HIDE_ONBOARDING: string = PREFIX + "ForceHideOnboardingHint";
export const KEYBOARD_FOCUS_BEGIN: string = PREFIX + "KeyboardFocusBegin";
export const KEYBOARD_FOCUS_END: string = PREFIX + "KeyboardFocusEnd";
export const KEYBOARD_REFOCUS: string = PREFIX + "KeyboardRefocus";
export const KEYBOARD_FOCUSABLE_INTERACTIVE_CHANGED: string = PREFIX + "KeyboardFocusableInteractiveChanged";
export const KEYBOARD_REMAP: string = PREFIX + "KeyboardRemap";
export const CLEAR_TOUCHES: string = PREFIX + "ClearTouches";

export const START_INTRO: string = PREFIX + "StartIntro";
export const INTRO_COMPLETED: string = PREFIX + "IntroCompleted";

export const SOLO_REQUESTED: string = PREFIX + "SoloRequested";
export const SOLO_STARTED: string = PREFIX + "SoloStarted";
export const SOLO_ENDED: string = PREFIX + "SoloEnded";
export const CANCEL_SOLO: string = PREFIX + "CancelSolo";
export const CULTURE_BUTTON_PRESSED: string = PREFIX + "CultureButtonPressed";
export const CULTURE_CHANGE_COMPLETE: string = PREFIX + "CultureChanged";
export const INSTRUMENT_PULL_OUT_STARTED: string = PREFIX + "InstrumentPullOutStarted";
export const INSTRUMENT_PULL_OUT_FINISHED: string = PREFIX + "InstrumentPullOutFinished";
export const SAMPLE_PAD_BUTTON_CLICKED: string = PREFIX + "SamplePadButtonClicked";
export const FX_BUTTON_CLICKED: string = PREFIX + "FXButtonClicked";

export const PLAY_CAPTION: string = "PlayCaption";
export const STOP_CAPTION: string = "StopCaption";

/** Called after all background elements have finished their swap tweens */
export const ALL_BG_SWAPS_COMPLETE: string = PREFIX + "AllBGElementSwapped";
export const ALL_INSTRUMENT_SWAPS_COMPLETE: string = PREFIX + "AllInstrumentPullOutFinished";
export const CULTURE_CHANGE_BEGIN: string = PREFIX + "CultureChangeBegin";
export const GAME_PAUSED: string = PREFIX + "Paused";
export const GAME_UNPAUSED: string = PREFIX + "UnPaused";

export const POWERUP_ONE_UNLOCKED: string = PREFIX + "PowerupOneUnlocked";
export const POWERUP_TWO_UNLOCKED: string = PREFIX + "PowerupTwoUnlocked";
export const POWERUP_THREE_UNLOCKED: string = PREFIX + "PowerupThreeUnlocked";

export const ENABLE_INPUT_CHARACTERS = PREFIX + "EnableInputCharacters";
export const ENABLE_INPUT = PREFIX + "EnableInput";
export const DISABLE_INPUT = PREFIX + "DisableInput";
